import { Link, generatePath } from 'react-router-dom'

import { adGroupBidRenderer } from 'components/FieldRenderers/Renderers/adGroup'
import {
    adGroupActiveBid,
    adGroupBid,
    adGroupCreatedDate,
    adGroupId,
    adGroupState,
    archiveAdGroup,
} from 'configuration/fieldCreators/adGroup'
import { brandCountryCode } from 'configuration/fieldCreators/brand'
import { campaignName } from 'configuration/fieldCreators/campaign'
import { labels } from 'configuration/fieldCreators/labels'
import { getPath } from 'routing/pagePaths'
import { CampaignGroupBy, ProfileGroupBy, Field, AdGroupFact } from 'types'

import { AMS_METRICS_COLUMNS_PAGES } from '../dataSources/ams'

export type AdGroupFactRecord = AdGroupFact<CampaignGroupBy & ProfileGroupBy>

export const adGroupsTableColumnsConfig: Field<AdGroupFactRecord>[] = [
    adGroupId({
        fixed: 'left',
    }),
    adGroupState(),
    adGroupBid({
        renderOptions: {
            render: (cellRenderProps) =>
                adGroupBidRenderer({
                    cellRenderProps,
                    dataIndex: ['ad_group', 'base_default_bid'],
                }),
        },
    }),
    adGroupActiveBid(),
    adGroupCreatedDate(),
    labels({ dataIndex: ['campaign', 'labels'], linkToTab: 'campaigns' }),
    ...(AMS_METRICS_COLUMNS_PAGES as Field<AdGroupFactRecord>[]),
    archiveAdGroup({ fixed: 'right' }),
]

export const adGroupsSummaryTableColumnsConfig: Field<AdGroupFactRecord>[] = [
    adGroupId({
        fixed: 'left',
    }),
    campaignName({
        dataIndex: ['campaign', 'name'],
        renderOptions: {
            render: ({ value, record }) => (
                <Link
                    to={generatePath(getPath('campaignPage'), {
                        campaignId: record.campaign.id,
                    })}
                >
                    {value}
                </Link>
            ),
        },
    }),
    brandCountryCode(),
    adGroupState(),
    adGroupBid({
        renderOptions: {
            render: (cellRenderProps) =>
                adGroupBidRenderer({
                    cellRenderProps,
                    dataIndex: ['ad_group', 'base_default_bid'],
                }),
        },
    }),
    adGroupActiveBid(),
    adGroupCreatedDate(),
    labels({ dataIndex: ['campaign', 'labels'], linkToTab: 'campaigns' }),
    ...(AMS_METRICS_COLUMNS_PAGES as Field<AdGroupFactRecord>[]),
    archiveAdGroup({ fixed: 'right' }),
]
